const DSC_URLS = { 
    GET_ALL: "/dsc/get_all",
    UPDATE: "/dsc/update",
    INSERT: "/dsc/insert",
    GET_ONE: "/dsc/get_one",
    DELETE: "/dsc/delete_one",
  };
  
  
  export {
    DSC_URLS
  };